import { Injectable, OnDestroy } from '@angular/core';
import { ServiceRouter } from '@pershing/pershing-core';
import { QuoteToggleServiceDefinition } from './quotetoggle-service-definition';
import { BehaviorSubject } from 'rxjs';
import { QuoteRef } from '../models/quoteRef-model';
import { QuoteToggleConstants } from '../utils/quotetoggle-constants';

@Injectable({
    providedIn: 'root'
})
export class QuoteToggleService implements OnDestroy {

    quotetoggleServiceUrl: string = '';
    public sessionRealtimeQuote$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public sessionAgreementSigned$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public quoteReference$: BehaviorSubject<QuoteRef[]> = new BehaviorSubject<QuoteRef[]>(null);
    public exchangeAgreeResponse$: BehaviorSubject<any> = new BehaviorSubject<false>(null);
    quoteReferenceList: QuoteRef[] = [];

    constructor(
        private serviceRouter: ServiceRouter) {
        this.quotetoggleServiceUrl = this.serviceRouter.getServiceRouteURL(QuoteToggleServiceDefinition.getInstance());
    }

    updateQuoteRef(data: QuoteRef) {
        // quote reference is per page, check if page never visisted, then add else, update page quote ref.
        if (this.quoteReferenceList.filter(item => { return item.pageName === data.pageName; }).length === 0) {
            this.quoteReferenceList.push(data);
        } else {
            this.quoteReferenceList.forEach(item => {
                if (item.pageName === data.pageName) {
                    item.asOfDate = data.asOfDate;
                    item.agreementSigned = data.agreementSigned;
                    item.realTimeRefOn = data.realTimeRefOn;
                    item.quoteAction = data.quoteAction;
                    item.isRTQuoteEntitled = data.isRTQuoteEntitled;
                }
                // synch up all other pages reference.  It's up to the page to further add logic e.g. agreement.
                if (data.quoteAction === QuoteToggleConstants.TOGGLE_ACTION) {
                    item.realTimeRefOn = data.realTimeRefOn;
                    this.sessionRealtimeQuote$.next(data.realTimeRefOn);
                } else if (data.quoteAction === QuoteToggleConstants.TOGGLE_ON_AGREE) {
                    item.realTimeRefOn = data.realTimeRefOn;
                    this.sessionRealtimeQuote$.next(data.realTimeRefOn);
                    this.sessionAgreementSigned$.next(data.agreementSigned);
                }
            });
        }
        this.quoteReference$.next(this.quoteReferenceList);
    }

    exchangeAgreementData(iEvent) {
        this.exchangeAgreeResponse$.next(iEvent);
        console.log("this.exchangeAgreeResponse$",iEvent);
    }

    ngOnDestroy(): void { }

}
